import React from 'react';
import PropTypes from 'prop-types';
import Preloader from '../Preloader';

const baseCls = 'lt-auth-preloader';

// TODO: возможно стоит вынести в компоненты

const FullScreenPreloader = ({ text }) => (
  <div className={`${baseCls} flex-center`}>
    <Preloader throbber />
    <div className={`${baseCls}__text`}>{text}</div>
  </div>
);

FullScreenPreloader.propTypes = {
  text: PropTypes.string.isRequired,
};

export default FullScreenPreloader;
